import { State, Action, StateContext } from '@ngxs/store';
import { CorePublicAction } from './core-public.actions';
import { Injectable } from '@angular/core';

export class CorePublicStateModel {
  public items: string[];
}

@Injectable()
@State<CorePublicStateModel>({
  name: 'corePublic',
  defaults: {
    items: []
  }
})
export class CorePublicState {
  @Action(CorePublicAction)
  add(ctx: StateContext<CorePublicStateModel>, action: CorePublicAction) {
    const state = ctx.getState();
    ctx.setState({ items: [ ...state.items, action.payload ] });
  }
}
